<template>
  <el-container class='container'>
    <el-header class="header">
      <el-select v-model="company" @change="changeCompany" value-key="companyId">
        <el-option v-for="i in userInfo.companys" :key="i.companyId" :value="i" :label="i.name"></el-option>
      </el-select>
      <div class="name">{{userInfo.realname}}</div>
      <el-button type="text" class="logout" @click="dialogVisible = true">退出登录</el-button>
    </el-header>
    <el-container>
      <el-aside width="160px" class="aside">
        <el-menu class="menu" router>
          <el-menu-item index="/topUp">
            <template slot="title">
              <i class="el-icon-money"></i>企业充值
            </template>
          </el-menu-item>
          <el-menu-item index="/welfarelist">
            <template slot="title">
              <i class="el-icon-sold-out"></i>福利发放
            </template>
          </el-menu-item>
          <el-menu-item index="/bill">
            <template slot="title">
              <i class="el-icon-tickets"></i>福利账单
            </template>
          </el-menu-item>
          <el-menu-item index="/mates" >
            <template slot="title">
              <i class="el-icon-setting"></i>员工管理
            </template>
          </el-menu-item>
          <!-- <el-menu-item index="/customer" v-show='companyId === "4341658182878208"'> -->
          <el-menu-item index="/customer">
            <template slot="title">
              <i class="el-icon-s-custom"></i>客户管理
            </template>
          </el-menu-item>
          <el-menu-item index="/department">
            <template slot="title">
              <i class="el-icon-wallet"></i>部门管理
            </template>
          </el-menu-item>
          <el-menu-item index="/OffPeakDining">
            <template slot="title">
              <i class="el-icon-wallet"></i>错峰用餐
            </template>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-main class="main">
        <router-view :key="routerViewKey"></router-view>
      </el-main>
    </el-container>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <span>是否退出登录</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="logOut">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import bus from '@/utils/bus'
export default {
  data () {
    return {
      company: {},
      dialogVisible: false,
      userInfo: {},
      account: 0,
      companyId: localStorage.getItem('companyId') || ''
    }
  },
  computed: {
    routerViewKey () {
      if (this.$route.name === 'OffPeakDining') {
        return `${this.$route.fullPath}-${this.companyId}`
      }
      return this.$route.fullPath
    }
  },
  mounted () {
    bus.$on('_Unauth', msg => {
      this.$message({
        type: 'warn',
        message: msg
      })
    })
    if (!localStorage.token) {
      this.$router.replace('/login')
    } else {
      /* 假如有token 就证明用户是登陆过的，这时候需要从本地读取之前选择的conpany */
      this.userInfo = JSON.parse(localStorage.userInfo)
      this.company = JSON.parse(localStorage.company)
      localStorage.companyId = this.company.companyId
      this.companyId = this.company.companyId
      // this.getMoney();
    }
  },
  destroyed () {
    bus.$off('_Unauth')
  },
  methods: {
    changeCompany (val) {
      this.company = val
      localStorage.company = JSON.stringify(val)
      localStorage.companyId = val.companyId
      localStorage.auth = val.identity
      this.companyId = val.companyId
      // this.getMoney();

      if (this.$route.name !== 'OffPeakDining') {
        bus.$emit('changeCompany', val.companyId)
      }
      // console.log(this.$route.path)
      // if(){
      // this.$router.replace('/welfarelist')

      // }
    },
    logOut () {
      // localStorage.companyId = ''
      // localStorage.userInfo = ''
      // localStorage.token = ''
      localStorage.clear()
      this.$router.replace('/login')
    }
  }
}
</script>

<style lang="scss" scoped>
%row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.container{
  width:100%;
}
.header {
  background: #3dd278;
  @extend %row;
  justify-content: flex-end;
  .name {
    margin: 0 10px;
    color: #fff;
  }
  .logout {
  }
}
.aside {
  height: calc(100vh - 60px);
  background-color: rgb(28, 36, 43);
  .menu {
    height: auto;
    background-color: rgb(28,36,43);
  }
  .el-menu-item {
    color: #fff;
  }

  .el-menu-item i {
    color: #fff;
  }

  .el-menu-item:focus,
  .el-menu-item:hover {
    background-color: rgb(28, 36, 43);
    color: #2ecc72;
  }

  .el-menu-item:focus i,
  .el-menu-item:hover i {
    color: #2ecc72;
  }

  .el-menu-item.is-active {
    background-color: rgb(28, 36, 43);
    color: #2ecc72;
  }

  .el-menu-item.is-active i {
    color: #2ecc72;
  }

  .el-menu-item [class^="el-icon-"] {
    /* margin-right: 15px; */
    font-size: 24px;
  }
}
.main{
  height: calc(100vh - 60px);
}
</style>
